import React from "react";
import { Tag, Hash, FileText, CheckCircle2 } from "lucide-react";
import { FormInput, FormSelect, FormTextarea } from "./SharedFormComponents";

export const BrandForm = ({ form, errors, handleInputChange }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 animate-in fade-in slide-in-from-bottom-2 duration-300">
      <FormInput
        icon={<Tag size={14} />}
        label="Brand Name"
        required
        field="brandName"
        value={form.brandName}
        onChange={handleInputChange}
        error={errors.brandName}
        placeholder="e.g. Hafele, Hettich"
      />
      <FormInput
        icon={<Hash size={14} />}
        label="Brand Code"
        field="brandCode"
        value={form.brandCode}
        onChange={handleInputChange}
        error={errors.brandCode}
        placeholder="e.g. HAF-001"
      />
      <div className="md:col-span-2">
        <FormTextarea
          icon={<FileText size={14} />}
          label="Description"
          field="description"
          value={form.description}
          onChange={handleInputChange}
          error={errors.description}
          placeholder="Brand details..."
        />
      </div>
      <div className="md:col-span-2">
        <FormSelect
          icon={<CheckCircle2 size={14} />}
          label="Status"
          required
          field="status"
          options={[
            { value: "ACTIVE", label: "Active" },
            { value: "INACTIVE", label: "Inactive" },
          ]}
          value={form.status || "ACTIVE"}
          onChange={handleInputChange}
          error={errors.status}
        />
      </div>
    </div>
  );
};
